import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  const errorMsg = `Missing Supabase environment variables.
    Required: VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY
    Found: VITE_SUPABASE_URL=${supabaseUrl ? '✓' : '✗'}, VITE_SUPABASE_ANON_KEY=${supabaseAnonKey ? '✓' : '✗'}`;
  throw new Error(errorMsg);
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Helper function to handle Supabase errors.
//
// PENTING: PostgrestError/AuthError dari supabase-js adalah PLAIN OBJECT,
// bukan instance Error. Versi lama hanya menangani `instanceof Error`,
// sehingga semua error PostgREST (PGRST116, PGRST200, RLS, dll) tertelan
// menjadi 'kesalahan yang tidak diketahui' — menyembunyikan akar masalah.
// Di sini kita ekstrak message/details/hint/code agar error nyata terlihat.
export const handleSupabaseError = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message;
  }

  if (error && typeof error === 'object') {
    const e = error as {
      message?: string;
      details?: string;
      hint?: string;
      code?: string;
    };
    const parts = [e.message, e.details, e.hint].filter(Boolean);
    if (parts.length > 0) {
      return e.code ? `${parts.join(' — ')} (${e.code})` : parts.join(' — ');
    }
  }

  return 'Terjadi kesalahan yang tidak diketahui';
};
